import { createAsyncAction } from 'typesafe-actions'
import { GetTransactionDetailsResponseDto } from '@sparling/financial-common'

export const {
  request: getTransactionDetailsRequest,
  success: getTransactionDetailsSuccess,
  failure: getTransactionDetailsFailure,
} = createAsyncAction(
  'GET_TRANSACTION_DETAILS_REQUEST',
  'GET_TRANSACTION_DETAILS_SUCCESS',
  'GET_TRANSACTION_DETAILS_FAILURE',
)<{ id: number }, GetTransactionDetailsResponseDto, Error>()
